import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZohoComponent } from './simple-icons-zoho.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZohoComponent ],
    exports:      [ SimpleIconsZohoComponent ],
    bootstrap:    []
})
export class SimpleIconsZohoModule {}
